<template>
    <x-ajax-dropdown :url="`/api/metrics`"
        @input="handleInput"
        :value="selectedResources"
        :placeholder="placeholder"
        :query="query"
        :blacklist="blacklist"
        :disabled="isLoading"
        label="name"
        trackBy="id"
        :allowEmpty="true"
        :multiple="true" />
</template>

<script>
import axios from 'axios'
import { get } from 'lodash'
import { emptyPromise, handleGeneralXhrError } from '../helpers'
import XAjaxDropdown from './XAjaxDropdown.vue'

export default {
    components: { XAjaxDropdown },
    created() {
        this.initSelectedResource()
    },
    data() {
        return {
            isLoading: false,
            selectedResources: null,
        }
    },
    methods: {
        fetchSelectedResources() {
            if (this.valueIsEmpty()) {
                this.selectedResources = []
                return emptyPromise()
            }
            this.isLoading = true
            const request = axios.get(`/api/metrics`, {
                params: {
                    ids: this.value.map(value => this.getItemId(value)),
                }
            })
            .then(response => {
                this.selectedResources = response.data.data
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        getItemId(item) {
            if (typeof item === 'object') {
                return get(item, 'id', null)
            }
            return item
        },
        handleInput(resources) {
            this.selectedResources = resources
            const parsedResources = resources.map(resource => this.defaultParser(resource))
            if (this.valueIsEmpty()) {
                this.$emit('input', parsedResources)
                return
            }
            this.$emit('input', this.valueIsObject() ? resources : parsedResources)
        },
        initSelectedResource() {
            if (!this.valueIsEmpty() && !this.valueIsObject()) {
                this.fetchSelectedResources()
                return
            }
            this.selectedResources = this.value
        },
        valueIsEmpty() {
            return this.value === null
        },
        valueIsObject() {
            return typeof _.get(this.value, '0', null) === 'object'
        },
    },
    props: {
        blacklist: {
            type: Array,
            required: false,
            default: () => [],
        },
        defaultParser: {
            type: Function,
            required: false,
            default: (data) => data.id,
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Pilih Metrics',
        },
        query: {
            type: Object,
            required: false,
            default: () => ({ }),
        },
        value: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    watch: {
        value: {
            handler() {
                this.initSelectedResource()
            },
            deep: true,
        }
    }
}
</script>